$(function() {

  // Init mobile menu
  $('ul.level-1', '#main-menu').slicknav({
    appendTo: 'header',
    allowParentLinks: true,
    label: '',
    duration: 130,
    init: function() {
      $('.slicknav_btn').detach().appendTo('.header-container').show();
    }
  });

  $('.load-more').each(function() {
    $(this).click(function() {
      var sel = $(this).data('selector');
      $(sel).fadeIn(350);
      $(this).hide();
      return false;
    });
  });
});
